import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { ThemeToggle } from '../ui/ThemeToggle'
import { companyNav, primaryNav } from '../../data/nav'

export function Header() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? 'border-ink/10 bg-paper/90 backdrop-blur' : 'border-transparent bg-paper/0'
      }`}
    >
      <Container className="flex h-20 items-center justify-between">
        <Link to="/" aria-label="Limitlast home">
          <img src="/logo-mark.svg" alt="Limitlast" width={500} height={500} className="h-30 w-auto md:h-32" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {primaryNav.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? 'text-signal' : 'text-ink/80 hover:text-ink'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="group relative">
            <button className="flex items-center gap-1 text-sm font-medium text-ink/80 hover:text-ink">
              Company
              <span className="text-xs transition-transform group-hover:rotate-180">▾</span>
            </button>
            <div className="invisible absolute right-0 top-full w-48 translate-y-1 rounded-2xl border border-ink/10 bg-paper p-2 opacity-0 shadow-xl shadow-ink/5 transition-all duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
              {companyNav.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="block rounded-xl px-4 py-2.5 text-sm text-ink/80 hover:bg-bone hover:text-ink"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />

          <div className="hidden lg:block">
            <CTA to="/contact" variant="primary">
              Let&apos;s talk
            </CTA>
          </div>

          <button
            className="flex h-10 w-10 flex-col items-center justify-center gap-1.5 lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <span className={`h-px w-6 bg-ink transition-transform ${open ? 'translate-y-[3.5px] rotate-45' : ''}`} />
            <span className={`h-px w-6 bg-ink transition-transform ${open ? '-translate-y-[3.5px] -rotate-45' : ''}`} />
          </button>
        </div>
      </Container>

      {open ? (
        <div className="border-t border-ink/10 bg-paper lg:hidden">
          <Container className="flex flex-col gap-1 py-6">
            {primaryNav.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="rounded-xl px-3 py-3 text-lg font-medium text-ink hover:bg-bone"
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 border-t border-ink/10 pt-2">
              {companyNav.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="block rounded-xl px-3 py-3 text-lg font-medium text-ink hover:bg-bone"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            <CTA to="/contact" variant="primary" className="mt-4 w-fit">
              Let&apos;s talk
            </CTA>
          </Container>
        </div>
      ) : null}
    </header>
  )
}
